import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-center px-6">
      <h1 className="text-6xl font-bold tracking-tight text-foreground">
        404
      </h1>
      <p className="mt-3 text-lg font-medium text-foreground">
        Page not found
      </p>
      <p className="mt-2 text-sm text-muted-foreground max-w-xs">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Button asChild className="mt-8">
        <Link to="/clients">Go to dashboard</Link>
      </Button>
    </div>
  );
}
